(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-combo-selector"] && !Shopify.designMode) return;
  try {
    class ComboSelector extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.combo-selector__list');
      this.cards = Array.from(this.querySelectorAll('[data-combo-card]'));
      this.atc = this.querySelector('[data-combo-atc]');
      if (!this.cards.length || !this.atc) return;

      let initial = this.cards.find((c) => c.getAttribute('aria-checked') === 'true') || this.cards[0];
      // If the default-selected option is sold out, fall back to the first available one.
      if (initial && this.isUnavailable(initial)) {
        const firstAvailable = this.cards.find((c) => !this.isUnavailable(c));
        if (firstAvailable) initial = firstAvailable;
      }
      this.selected = initial;
      this.select(this.selected, false);

      this.cards.forEach((card) => {
        card.addEventListener('click', () => this.select(card, true));
      });

      // Radiogroup keyboard navigation (roving tabindex + arrow keys).
      this.list.addEventListener('keydown', (event) => this.onKeydown(event));

      this.atc.addEventListener('click', () => this.addToCart());

      this.initVariantDialog();
      this.initTimer();
    }

    initVariantDialog() {
      this.dialog = this.querySelector('[data-combo-variant-dialog]');
      if (!this.dialog) return;
      this.vdImg = this.dialog.querySelector('[data-vd-img]');
      this.vdTitle = this.dialog.querySelector('[data-vd-title]');
      this.vdPrice = this.dialog.querySelector('[data-vd-price]');
      this.vdLabel = this.dialog.querySelector('[data-vd-optlabel]');
      this.vdOptions = this.dialog.querySelector('[data-vd-options]');
      this.vdConfirm = this.dialog.querySelector('[data-vd-confirm]');
      this.vdConfirmLabel = this.dialog.querySelector('[data-vd-confirm-label]');
      this.vdDefaultLabel = this.vdConfirmLabel ? this.vdConfirmLabel.textContent : 'Add to cart';

      this.dialog.querySelector('[data-vd-close]')?.addEventListener('click', () => this.closeDialog());
      this.vdConfirm?.addEventListener('click', () => this.confirmVariant());
      // Click on the backdrop (the dialog element itself) closes it.
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.closeDialog();
      });
    }

    openVariantDialog(card) {
      if (!this.dialog) {
        // No dialog available — fall back to adding the default variant.
        this.addVariant(card.getAttribute('data-variant-id'));
        return;
      }
      let data;
      try { data = JSON.parse(card.getAttribute('data-combo-variants') || '{}'); } catch (e) { data = {}; }
      const items = Array.isArray(data.items) ? data.items : [];
      if (!items.length) {
        this.addVariant(card.getAttribute('data-variant-id'));
        return;
      }

      this.vdTitle.textContent = data.title || '';
      if (data.image) {
        this.vdImg.src = data.image;
        this.vdImg.alt = data.title || '';
        this.vdImg.style.display = '';
      } else {
        this.vdImg.style.display = 'none';
      }
      this.vdLabel.textContent = 'Select ' + (data.optionName || 'option');

      this.vdOptions.innerHTML = '';
      items.forEach((it) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'combo-selector__vd-option';
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', 'false');
        b.setAttribute('data-variant-id', it.id);
        b.setAttribute('data-price', it.price || '');
        if (!it.available || !it.id) {
          b.disabled = true;
          b.setAttribute('aria-disabled', 'true');
        }
        if (it.image) {
          // Image swatches (e.g. footwear colourways) take precedence over a
          // solid hex fill, so the chooser shows the product imagery rather
          // than falling back to a text-only label.
          const sw = document.createElement('span');
          sw.className = 'combo-selector__vd-swatch';
          sw.style.backgroundImage = `url("${it.image}")`;
          sw.style.backgroundSize = 'cover';
          sw.style.backgroundPosition = 'center';
          b.appendChild(sw);
        } else if (it.hex) {
          const sw = document.createElement('span');
          sw.className = 'combo-selector__vd-swatch';
          sw.style.background = it.hex;
          b.appendChild(sw);
        }
        const label = document.createElement('span');
        label.textContent = it.label;
        b.appendChild(label);
        b.addEventListener('click', () => this.selectVariantOption(b));
        this.vdOptions.appendChild(b);
      });

      const firstAvailable = Array.from(this.vdOptions.children).find((b) => !b.disabled);
      if (firstAvailable) {
        this.selectVariantOption(firstAvailable);
      } else {
        this.vdSelected = null;
        this.vdConfirm.disabled = true;
      }

      this.dialog.showModal();
    }

    selectVariantOption(btn) {
      Array.from(this.vdOptions.children).forEach((b) => {
        const on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      this.vdSelected = btn.getAttribute('data-variant-id');
      this.vdConfirm.disabled = false;
      const price = btn.getAttribute('data-price');
      if (this.vdConfirmLabel) {
        this.vdConfirmLabel.textContent = price ? `${this.vdDefaultLabel} · ${price}` : this.vdDefaultLabel;
      }
    }

    async confirmVariant() {
      if (!this.vdSelected) return;
      const ok = await this.addVariant(this.vdSelected, this.vdConfirm);
      if (ok) {
        this.closeDialog();
        this.openCartDrawer();
      }
    }

    closeDialog() {
      if (this.dialog && this.dialog.open) this.dialog.close();
    }

    disconnectedCallback() {
      if (this.timerId) clearInterval(this.timerId);
    }

    isUnavailable(card) {
      return card.getAttribute('data-available') !== 'true';
    }

    select(card, focus) {
      if (!card || this.isUnavailable(card)) {
        // Keep selection on an available card; ignore selecting sold-out options.
        if (card && this.isUnavailable(card) && card !== this.selected) return;
      }
      this.cards.forEach((c) => {
        const on = c === card;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
        c.tabIndex = on ? 0 : -1;
      });
      this.selected = card;
      if (focus) card.focus();
      this.updateAtcAvailability();
    }

    updateAtcAvailability() {
      const anyAvailable = this.cards.some((c) => !this.isUnavailable(c));
      const label = this.atc.querySelector('.combo-selector__atc-label');
      const blocked = !anyAvailable || !this.selected || this.isUnavailable(this.selected);
      if (blocked) {
        if (label && this._defaultLabel == null) this._defaultLabel = label.textContent;
        if (label) label.textContent = 'Sold out';
        this.atc.setAttribute('disabled', '');
      } else {
        if (label && this._defaultLabel != null) label.textContent = this._defaultLabel;
        this.atc.removeAttribute('disabled');
      }
    }

    onKeydown(event) {
      const keys = ['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'];
      if (!keys.includes(event.key)) return;
      event.preventDefault();
      const i = this.cards.indexOf(this.selected);
      const forward = event.key === 'ArrowDown' || event.key === 'ArrowRight';
      const next = this.cards[(i + (forward ? 1 : -1) + this.cards.length) % this.cards.length];
      this.select(next, true);
    }

    async addToCart() {
      const card = this.selected;
      if (!card || this.isUnavailable(card)) return;
      // Products with multiple variants open the chooser popup; single-variant
      // products add their one variant directly.
      if (card.getAttribute('data-has-variants') === 'true') {
        this.openVariantDialog(card);
        return;
      }
      const ok = await this.addVariant(card.getAttribute('data-variant-id'));
      if (ok) this.openCartDrawer();
    }

    async addVariant(variantId, button) {
      const btn = button || this.atc;
      if (!variantId || btn.getAttribute('aria-busy') === 'true') return false;

      btn.setAttribute('aria-busy', 'true');
      let ok = false;
      try {
        const addRes = await fetch(`${(window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js'}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
        });
        if (!addRes.ok) {
          const err = await addRes.json().catch(() => ({}));
          throw new Error(err.description || err.message || 'Add to cart failed');
        }
        const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = cartRes.ok ? await cartRes.json() : undefined;
        // Dispatch the theme's cart-update event (same name as Horizon's
        // CartAddEvent) so the cart icon + drawer contents refresh.
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'combo-selector', data: { source: 'combo-selector', variantId } },
          })
        );
        ok = true;
      } catch (e) {
        console.error('[combo-selector]', e);
      } finally {
        btn.removeAttribute('aria-busy');
      }
      return ok;
    }

    /* Open the theme's cart drawer. It only auto-opens on cart:update when it has
       the `auto-open` attribute, so we call its public open() directly. */
    openCartDrawer() {
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') drawer.open();
    }

    initTimer() {
      const bar = this.querySelector('[data-combo-timer]');
      if (!bar) return;
      const h = bar.querySelector('[data-h]');
      const m = bar.querySelector('[data-m]');
      const s = bar.querySelector('[data-s]');
      if (!h || !m || !s) return;

      const minutes = Math.max(1, parseInt(bar.getAttribute('data-minutes'), 10) || 15);
      const key = `combo-timer-${this.className.split(' ').find((c) => c.startsWith('combo-selector--')) || 'default'}`;
      const now = Date.now();
      let deadline = parseInt(localStorage.getItem(key), 10);
      if (!deadline || deadline <= now) {
        deadline = now + minutes * 60000;
        try { localStorage.setItem(key, String(deadline)); } catch (e) {}
      }

      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        let diff = deadline - Date.now();
        if (diff <= 0) {
          // Restart the window so the urgency cue stays live.
          deadline = Date.now() + minutes * 60000;
          try { localStorage.setItem(key, String(deadline)); } catch (e) {}
          diff = deadline - Date.now();
        }
        const total = Math.floor(diff / 1000);
        h.textContent = pad(Math.floor(total / 3600));
        m.textContent = pad(Math.floor((total % 3600) / 60));
        s.textContent = pad(total % 60);
      };
      tick();
      this.timerId = setInterval(tick, 1000);
    }
  }

  if (!customElements.get('combo-selector')) {
    customElements.define('combo-selector', ComboSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["frido-chair-mobile-swatches"] && !Shopify.designMode) return;
  try {
    (function () {
    if (document.documentElement.dataset.fridoChairSwatchesBound === 'true') return;
    document.documentElement.dataset.fridoChairSwatchesBound = 'true';

    function markSelected(wrap, predicate) {
      let selectedLabel = null;
      wrap.querySelectorAll('[data-frido-chair-swatch]').forEach((b) => {
        const isSelected = predicate(b);
        b.classList.toggle('is-selected', isSelected);
        b.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        if (isSelected) selectedLabel = b.getAttribute('data-option-value');
      });
      // Keep the desktop "Color: <value>" header in sync.
      const valueEl = wrap.querySelector('[data-frido-chair-value]');
      if (valueEl && selectedLabel) valueEl.textContent = selectedLabel;
    }

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const btn = target.closest('[data-frido-chair-swatch]');
      if (!btn) return;

      const wrap = btn.closest('[data-frido-chair-swatches]');
      const optionValueId = btn.getAttribute('data-option-value-id');
      const optionValue = btn.getAttribute('data-option-value');
      if (!optionValueId && !optionValue) return;

      // Find the matching radio input inside the on-page variant picker.
      let input = null;
      if (optionValueId) {
        input = document.querySelector(
          'variant-picker input[type="radio"][data-option-value-id="' + optionValueId + '"]'
        );
      }
      if (!input && optionValue) {
        const candidates = document.querySelectorAll('variant-picker input[type="radio"]');
        for (const c of candidates) {
          if (c.value === optionValue) { input = c; break; }
        }
      }
      if (!input || input.disabled) return;

      // Optimistic visual update so the yellow ring follows the tap immediately.
      if (wrap) markSelected(wrap, (b) => b === btn);

      // Set checked state and dispatch a bubbling change event on the input.
      // Variant-picker.js listens for 'change' on itself, so the event bubbles
      // up and triggers the same flow as a real radio click — without moving
      // focus to the off-screen radio (which would auto-scroll the page).
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Sync from external variant changes (URL nav, regular picker click, etc.)
    document.addEventListener('variant:update', (event) => {
      const variantId = event?.detail?.resource?.id;
      if (!variantId) return;
      // Find the radio in the regular picker that corresponds to the new variant
      // and read its option-value-id — that's the id we match against our swatches.
      const radio = document.querySelector(
        'variant-picker input[type="radio"][data-variant-id="' + variantId + '"]'
      );
      const targetId = radio?.getAttribute('data-option-value-id');
      if (!targetId) return;
      document.querySelectorAll('[data-frido-chair-swatches]').forEach((wrap) => {
        markSelected(wrap, (b) => b.getAttribute('data-option-value-id') === targetId);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["frido-footwear-exchange-badge"] && !Shopify.designMode) return;
  try {
    (function () {
    if (document.documentElement.dataset.fridoFwExchangeBound === 'true') return;
    document.documentElement.dataset.fridoFwExchangeBound = 'true';

    function inject() {
      const tpl = document.querySelector('[data-frido-fw-exchange-template]');
      if (!tpl) return;
      const text = tpl.getAttribute('data-text');
      if (!text) return;

      // Find every ATC button (in-flow + sticky) on the page and add the line
      // unless it's already injected.
      const buttons = document.querySelectorAll('.add-to-cart-button');
      buttons.forEach((btn) => {
        if (btn.querySelector('.frido-fw-exchange-line')) return;
        // Skip the sticky bar's ATC — its layout differs.
        if (btn.closest('.sticky-add-to-cart__bar')) return;

        const line = document.createElement('span');
        line.className = 'frido-fw-exchange-line';
        line.innerHTML =
          '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="14" height="14" aria-hidden="true">' +
            '<path d="M8 1.5 2.5 3.6v4.2c0 3.4 2.4 5.5 5.5 6.7 3.1-1.2 5.5-3.3 5.5-6.7V3.6L8 1.5Z" stroke="#86700d" stroke-width="1.4" fill="none" stroke-linejoin="round"/>' +
            '<path d="m5.7 8 1.6 1.6L10.3 6.6" stroke="#86700d" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
          '<span>' + text.replace(/[<>&"]/g, (c) => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c])) + '</span>';
        btn.appendChild(line);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', inject, { once: true });
    } else {
      inject();
    }
    // Re-inject after section re-renders (variant updates, etc).
    document.addEventListener('variant:update', () => setTimeout(inject, 50));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["frido-footwear-mobile-variants"] && !Shopify.designMode) return;
  try {
    (function () {
    if (document.documentElement.dataset.fridoFwVariantsBound === 'true') return;
    document.documentElement.dataset.fridoFwVariantsBound = 'true';

    function markSelected(card, predicate) {
      card.querySelectorAll('[data-frido-fw-swatch]').forEach((b) => {
        const isSelected = predicate(b);
        b.classList.toggle('is-selected', isSelected);
        b.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      });
    }

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const btn = target.closest('[data-frido-fw-swatch]');
      if (!btn) return;
      if (btn.getAttribute('aria-disabled') === 'true') return;

      const card = btn.closest('.frido-fw-variants__card');
      const optionValueId = btn.getAttribute('data-option-value-id');
      const optionValue = btn.getAttribute('data-option-value');

      let input = null;
      if (optionValueId) {
        input = document.querySelector(
          'variant-picker input[type="radio"][data-option-value-id="' + optionValueId + '"]'
        );
      }
      if (!input && optionValue) {
        const position = btn.getAttribute('data-option-position');
        const candidates = document.querySelectorAll('variant-picker input[type="radio"]');
        for (const c of candidates) {
          if (c.value === optionValue && (!position || c.getAttribute('data-input-id')?.startsWith(position + '-'))) {
            input = c;
            break;
          }
        }
      }
      if (!input || input.disabled) return;

      // Optimistic visual swap.
      if (card) {
        markSelected(card, (b) => b === btn);
        const label = card.querySelector('[data-frido-fw-selected-label]');
        if (label) label.textContent = optionValue || '';
      }

      // Dispatch change directly on the input — no focus = no auto-scroll.
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    document.addEventListener('variant:update', (event) => {
      const variantId = event?.detail?.resource?.id;
      if (!variantId) return;
      // Find every radio in the regular picker that's part of the new variant.
      const radios = document.querySelectorAll(
        'variant-picker input[type="radio"][data-variant-id="' + variantId + '"]'
      );
      if (!radios.length) return;
      const selectedIds = new Set();
      radios.forEach((r) => {
        const id = r.getAttribute('data-option-value-id');
        if (id) selectedIds.add(id);
      });
      document.querySelectorAll('[data-frido-fw-variants] .frido-fw-variants__card').forEach((card) => {
        let updatedValue = '';
        card.querySelectorAll('[data-frido-fw-swatch]').forEach((b) => {
          const isSel = selectedIds.has(b.getAttribute('data-option-value-id'));
          b.classList.toggle('is-selected', isSel);
          b.setAttribute('aria-checked', isSel ? 'true' : 'false');
          if (isSel) updatedValue = b.getAttribute('data-option-value') || '';
        });
        const label = card.querySelector('[data-frido-fw-selected-label]');
        if (label && updatedValue) label.textContent = updatedValue;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["frido-pdp-limited-time-offer"] && !Shopify.designMode) return;
  try {
    class FridoLto extends HTMLElement {
    connectedCallback() {
      this.elH = this.querySelector("[data-h]");
      this.elM = this.querySelector("[data-m]");
      this.elS = this.querySelector("[data-s]");
      if (!this.elH || !this.elM || !this.elS) return;
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }

    tick() {
      const now = new Date();
      const end = new Date(now);
      end.setHours(23, 59, 59, 999);
      let diff = end - now;
      if (diff < 0) diff = 0;
      const h = Math.floor(diff / 3600000);
      diff -= h * 3600000;
      const m = Math.floor(diff / 60000);
      diff -= m * 60000;
      const s = Math.floor(diff / 1000);
      this.elH.textContent = String(h).padStart(2, "0");
      this.elM.textContent = String(m).padStart(2, "0");
      this.elS.textContent = String(s).padStart(2, "0");
    }
  }

  if (!customElements.get("frido-lto")) {
    customElements.define("frido-lto", FridoLto);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["frido-sticky-choose-variant"] && !Shopify.designMode) return;
  try {
    (function () {
    function init() {
      var bar = document.querySelector('[data-frido-scv]');
      if (!bar || bar.dataset.scvReady === '1') return;
      bar.dataset.scvReady = '1';

      // Reparent to <body> so position:fixed is measured against the viewport,
      // never a transformed/overflow-clipped ancestor (blocks render deep in
      // the buybox).
      if (bar.parentElement !== document.body) document.body.appendChild(bar);
      bar.removeAttribute('hidden');

      var selector = bar.getAttribute('data-target') || '';
      var fadeWhenVisible = bar.getAttribute('data-fade-when-visible') !== 'false';
      var btn = bar.querySelector('[data-frido-scv-btn]');

      function setHidden(hidden) {
        bar.setAttribute('data-hidden', hidden ? 'true' : 'false');
      }
      setHidden(false);

      function resolveTarget() {
        return selector ? document.querySelector(selector) : null;
      }

      if (btn) {
        btn.addEventListener('click', function () {
          var t = resolveTarget();
          if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }

      // The variant snippets render server-side (stable .sai-* class), but guard
      // against late hydration by retrying briefly before wiring the observer.
      var tries = 0;
      (function wireObserver() {
        var target = resolveTarget();
        if (!target) {
          if (tries++ < 40) { setTimeout(wireObserver, 100); return; }
          return; // give up: bar stays visible, click is a no-op — fail-safe.
        }
        if (!('IntersectionObserver' in window) || !fadeWhenVisible) return;
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) { setHidden(e.isIntersecting); });
          },
          { threshold: 0.25 }
        );
        io.observe(target);
      })();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
